import { ObjectMeta, VersionCreationJob } from "@supernova-studio/model";
import { DTOCreateVersionInput } from "../../payloads";
import { z } from "zod";
export const DTODesignSystemVersion = z.object({
    id: z.string(),
    createdAt: z.coerce.date(),
    meta: ObjectMeta,
    version: z.string(),
    isReadonly: z.boolean(),
    changeLog: z.string(),
    designSystemId: z.string(),
});
export const DTODesignSystemVersionsListResponse = z.object({
    designSystemVersions: z.array(DTODesignSystemVersion),
});
export const DTODesignSystemVersionGetResponse = z.object({
    designSystemVersion: DTODesignSystemVersion,
});
export const DTODesignSystemVersionCreationResponse = z.object({
    meta: ObjectMeta,
    version: z.string(),
    changeLog: z.string(),
    isReadOnly: z.boolean(),
    designSystemId: z.string(),
    jobId: z.string(),
});
export const VersionSQSPayload = z.object({
    jobId: z.string(),
    designSystemId: z.string(),
    input: DTOCreateVersionInput,
});
export const DTODesignSystemVersionJobsResponse = z.object({
    jobs: z.array(VersionCreationJob),
});
// Creation job status response
export const DTODesignSystemVersionJobStatusResponse = z.object({
    job: VersionCreationJob,
});
